import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';
import {NgForm} from '@angular/forms';


declare var $: any;
declare var body: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.css']
})
export class LogsComponent implements OnInit {
  nao = new Nanobar();
  logsData: any;
  logsDeleteData: any;
  deleteLogsId: any;
  loadindData = true;
  paginatedDataLogs: any;
  logsPageCount = 0;
  logsLastPage = true;
  deleteBtndDisable = false;
  type = 3;
  limit = 25;
  status = 0;
  messagesDetail: any;
  dispensaryListing: any;
  dispensaryId = '-1';
  constructor(private dataService: DataService, private router: Router) { }
  getLogs() {
    this.loadindData = true;
    this.nao.go(30);
    this.dataService.getLogslisting(window.localStorage.getItem('token'), this.type, this.limit, this.status, this.dispensaryId).subscribe(
      (data) => {
        this.nao.go(100);
        this.logsData = data;
        this.logsLastPage = this.logsData.last_page;
        this.logsPageCount++;
        this.logsData = this.logsData.items;

        this.loadindData = false;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getLogsFun(type) {
    this.status = 0;
    this.logsPageCount = 0;
    this.type = type;
    this.getLogs();
  }

  getLogDetails(keyword) {
    this.nao.go(30);
    this.dataService.getLogDetails(window.localStorage.getItem('token'), this.type, this.status, this.dispensaryId, keyword).subscribe(
      (data: any) => {
        console.log('new logs api data test', data);
        this.nao.go(100);
        this.messagesListingFunc(data.items)
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getLogslistingByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getLogslistingByPage(window.localStorage.getItem('token'), this.type, this.logsPageCount, this.limit, this.status, this.dispensaryId).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataLogs = data;
        this.logsLastPage = this.paginatedDataLogs.last_page;
        this.logsPageCount++;
        this.paginatedDataLogs = this.paginatedDataLogs.items;
        for ( var i = 0; i < this.paginatedDataLogs.length; i++) {
          this.logsData.push(this.paginatedDataLogs[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  openDeleteLogsPopup(id) {
    this.deleteLogsId = id;
    $('#deleteLogsPopup').modal('show');
  }
  deleteConform() {
    this.deleteBtndDisable = true;
    this.nao.go(30);
    this.dataService.deleteStory(window.localStorage.getItem('token'), this.deleteLogsId).subscribe(
      (data) => {
        this.nao.go(100);
        this.logsDeleteData = data;
        this.deleteBtndDisable = false;
        if ( this.logsDeleteData.success === true ) {
          this.getLogs();
          $('#deleteLogsPopup').modal('hide');
        }
        this.getLogs();
        $('#deleteLogsPopup').modal('hide');
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  changeLogStatus(status) {
    if ( status === 'All' ) {
      this.status = 0;
    }
    if ( status === 'Found' ) {
      this.status = 1;
    }
    if ( status === 'Not Found' ) {
      this.status = 2;
    }
    this.logsPageCount = 0;
    this.getLogs();
  }
  changeLogDispensary(status) {
    this.dispensaryId = status;
    this.logsPageCount = 0;
    this.getLogs();
  }

  messagesListingFunc(list){
    this.messagesDetail = list;
    $('#tagDetails').modal('show');
  }

  dispencoryListing() {
    this.dataService.getDispencoryListing(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.dispensaryListing = data;
      },
      (error) => {
      }
    );
  }
  ngOnInit() {
    this.getLogs();
    this.dispencoryListing();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#logs').css('color', '#d77229');
  }

}



// WEBPACK FOOTER //
// ./src/app/logs/logs.component.ts